import cn from 'classnames'
import type { ComponentProps, PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import css from '../List.css'
import { ListItemControls } from './ListItemControls'
import { ListItemDate } from './ListItemDate'
import { ListItemIcon } from './ListItemIcon'
import { ListItemName } from './ListItemName'
import { ListItemRight } from './ListItemRight'

type ListItemProps = ComponentProps<'span'>

const ListItemImpl = forwardRef<HTMLElement, PropsWithChildren<ListItemProps>>(
  function ListItemImpl({ children, className, ...rest }, ref) {
    return (
      <span ref={ref} className={cn(css.item, className)} {...rest}>
        {children}
      </span>
    )
  },
)

export const ListItem = Object.assign(ListItemImpl, {
  Icon: ListItemIcon,
  Controls: ListItemControls,
  Date: ListItemDate,
  Name: ListItemName,
  Right: ListItemRight,
})
